import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components //
import { CheckIcon } from 'components/Icons';
import Text from 'components/Text';

const Root = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding: 16px 0px;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;

  & + & {
    margin-top: 16px
  }

  & > ${ Text } {
    margin-left: 19px;
  }
`;

class List extends PureComponent {

  static propTypes = {
    items: PropTypes.array.isRequired,
  };

  _renderItems = () => {
    const { items } = this.props;
    return items.map(item => (
      <ListItem>
        <CheckIcon
          size={12}
        />
        <Text>
          { item }
        </Text>
      </ListItem>
    ))
  }

  render() {
    return (
      <Root>
        { this._renderItems() }
      </Root>
    );
  }
}

export default List;
